
<template>
      <div class="no-permission">
          <el-dialog title="提示" v-model="dialogVisible" @close="handleDialogClose">
              <div class="no-permi-tips">
                  <p>{{ $t('ash.noPerTips') }}</p>
                  <a @click="handlerGotoLogin">{{ $t('header.login') }}</a> | <a @click="handlerGotoIndex">{{ $t('header.home') }}</a>
              </div>
          </el-dialog>
      </div>
</template>

<script>
import { mapState } from 'vuex'
import loginLogout from '../../../services/LoginLogout.js'
export default {
    data() {
        return { dialogVisible: false };
    },
    computed: {
        ...mapState({ showNoPermission: state => state.common.showNoPermission })
    },
    watch: {
        showNoPermission(newVal, oldVal) { this.dialogVisible = newVal }
    },
    methods: {
        handleDialogClose() { this.$store.commit('common/setShowNoPremission', false) },
        handlerGotoLogin() { loginLogout.login() },
        handlerGotoIndex() { this.$router.push('/home') }
    }
}
</script>

<style lang="less" scoped>
@import './css/index.less';
</style>
